import UpdateArtefact from "../../components/artefact/UpdateArtefact";

const ArtefactUpdatePage = () => {
  return (
    <div className="flex flex-col items-cener gap-5 p-10 h-full">
      <div className="bg-gradient-to-r from-darkPurple to-softPurple w-full p-5 h-auto">
        <p className="text-white">Artefaktų atnaujinimas</p>
      </div>
      <div className="flex justify-center h-full">
        <UpdateArtefact />
      </div>
    </div>
  );
};

export default ArtefactUpdatePage;
